import React from 'react'
import ContactLayout from './contactlayout';
import BecomePartner from './becomepartner';

const BecomePartnerPage = () => {
    return (
        <ContactLayout>
            <BecomePartner />
        </ContactLayout>
    )
}

export default BecomePartnerPage
